import { Component, input } from '@angular/core';

import { BadgeComponent } from '@camelot/ui';

import { CommunicationType } from '../../services/dto/communication';

@Component({
  selector: 'cam-communication-type',
  templateUrl: './communication-type.component.html',
  styleUrls: ['./communication-type.component.scss'],
  imports: [BadgeComponent],
})
export class CommunicationTypeComponent {
  value = input.required<CommunicationType>();

  public getTranslate() {
    return `communication.type.${CommunicationType[this.value() ?? CommunicationType.Unknown].toLocaleLowerCase()}`;
  }
}
